import { PropertyCharacteristic } from '@contexts/Estate';

const ESTATE_ATTRIBUTES = {
  BEDROOMS: 'nro-cuartos',
  AREA: 'area-construida',
};

const CHARACTERISTICS_TO_EXTRACT = {'nro-cuartos': 1, 'area-construida': 0};

function extractCharacteristics(characteristics: PropertyCharacteristic[] = [], keys = {}) {
  const keyNames = Object.keys(keys);
  return characteristics
    .filter((characteristic) => keyNames.includes(characteristic.slug))
    .reduce((object, entry) => {
      object[entry.slug] = parseInt(entry.value);
      return object;
    }, Object.assign({}, keys));
}

export { ESTATE_ATTRIBUTES, CHARACTERISTICS_TO_EXTRACT, extractCharacteristics };
